// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge, .Card.selected.duet.neutral:after {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f9e5a9;
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin: 0.3rem;
  min-width: 1rem;
  border-radius: 8px;
  padding: 3px; }

.Card {
  border: 1px solid;
  cursor: pointer;
  margin: 0.5rem;
  position: relative;
  border-radius: 12px; }
  .Card .CardContextMenu {
    position: absolute;
    z-index: 2;
    left: 20%;
    top: 20%;
    width: 100%; }
  .Card .card-id {
    left: 0;
    position: absolute;
    top: 0;
    height: 15%;
    width: 15%; }
  .Card .card-img {
    width: 100%;
    border-radius: 12px;
    -webkit-user-select: none;
            user-select: none; }
    .Card .card-img.enlarged {
      border: 2px solid;
      left: -50%;
      position: absolute;
      top: -50%;
      width: 200%;
      z-index: 2; }
  .Card.selected.red:after {
    background-color: rgba(255, 0, 0, 0.5);
    border-color: red; }
  .Card.selected.blue:after {
    background-color: rgba(0, 149, 255, 0.5);
    border-color: #0095ff; }
  .Card.selected.green:after {
    background-color: rgba(0, 177, 6, 0.5);
    border-color: #00b106; }
  .Card.selected.neutral:after {
    background-color: rgba(255, 212, 0, 0.5);
    border-color: #ffd400; }
  .Card.selected.black:after {
    background-color: rgba(0, 0, 0, 0.5);
    border-color: #000; }
  .Card.selected:after {
    content: "";
    border: 4px solid;
    box-sizing: border-box;
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    border-radius: 12px; }
  .Card.selected.duet.neutral:after {
    border: 2px solid;
    height: 15%;
    width: 15%;
    left: unset;
    right: 0;
    content: "x"; }
`, "",{"version":3,"sources":["webpack://./src/components/library/Badge.scss","webpack://./src/style/colors.scss","webpack://./src/components/Card.scss"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBCNkB;EDOlB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY,EAAA;;AEDd;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB,EAAA;EALrB;IAQI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,WAAW,EAAA;EAZf;IAgBI,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU,EAAA;EApBd;IAwBI,WAAW;IACX,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB,EAAA;IA1BrB;MA6BM,iBAAiB;MACjB,UAAU;MACV,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,UAAU,EAAA;EAzCZ;IACE,sCDHqB;ICIrB,iBDJqB,EAAA;ECEvB;IACE,wCDJwB;ICKxB,qBDLwB,EAAA;ECG1B;IACE,sCDDuB;ICEvB,qBDFuB,EAAA;ECAzB;IACE,wCDF0B;ICG1B,qBDH0B,EAAA;ECC5B;IACE,oCDWW;ICVX,kBDUW,EAAA;ECLjB;IA0CM,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,MAAM;IACN,mBAAmB,EAAA;EAlDzB;IAuDM,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY,EAAA","sourcesContent":["@import \"./../../style/colors\";\n\n.Badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: $background;\n  color: #000;\n  font-size: 1rem;\n  font-weight: bold;\n  margin: 0.3rem;\n  min-width: 1rem;\n  border-radius: 8px;\n  padding: 3px;\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n","@import \"./../style/colors\";\n@import \"./library/Badge\";\n\n@mixin card-overlay {\n  @each $name, $hex in $cardColors {\n    &.#{$name}:after {\n      background-color: rgba($hex, 0.5);\n      border-color: $hex;\n    }\n  }\n}\n\n.Card {\n  border: 1px solid;\n  cursor: pointer;\n  margin: 0.5rem;\n  position: relative;\n  border-radius: 12px;\n\n  .CardContextMenu {\n    position: absolute;\n    z-index: 2;\n    left: 20%;\n    top: 20%;\n    width: 100%;\n  }\n\n  .card-id {\n    left: 0;\n    position: absolute;\n    top: 0;\n    height: 15%;\n    width: 15%;\n  }\n\n  .card-img {\n    width: 100%;\n    border-radius: 12px;\n    user-select: none;\n\n    &.enlarged {\n      border: 2px solid;\n      left: -50%;\n      position: absolute;\n      top: -50%;\n      width: 200%;\n      z-index: 2;\n    }\n  }\n\n  &.selected {\n    @include card-overlay();\n\n    &:after {\n      content: \"\";\n      border: 4px solid;\n      box-sizing: border-box;\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      left: 0;\n      top: 0;\n      border-radius: 12px;\n    }\n\n    &.duet.neutral:after {\n      @extend .Badge;\n      border: 2px solid;\n      height: 15%;\n      width: 15%;\n      left: unset;\n      right: 0;\n      content: \"x\";\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
